export default function HeroSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-start overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3cb1c66169d46b1b40c66f468f43c009.jpg"
          alt="Allen Construction Group - DFW Construction"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-28 pb-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/40 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></div>
            <span className="text-orange-300 text-sm font-semibold tracking-widest uppercase">DFW&apos;s Trusted Builder</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-6">
            Building <span className="text-orange-400">Dreams</span><br />
            Across DFW
          </h1>

          <p className="text-lg md:text-xl text-gray-200 leading-relaxed mb-10 max-w-xl">
            Expert new construction framing, concrete, and remodeling services. Allen Construction Group delivers quality craftsmanship you can count on.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-md text-base transition-all hover:scale-105 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Start Your Project
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
            <a
              href="#projects"
              onClick={(e) => { e.preventDefault(); handleNav('#projects'); }}
              className="border-2 border-white/60 hover:border-white text-white font-bold px-8 py-4 rounded-md text-base transition-all hover:bg-white/10 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              View Our Work
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-gallery-line"></i>
              </div>
            </a>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
          {[
            { value: '500+', label: 'Projects Completed' },
            { value: '15+', label: 'Years Experience' },
            { value: '100%', label: 'Licensed & Insured' },
            { value: 'DFW', label: 'Service Area' },
          ].map((stat) => (
            <div key={stat.label} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 text-center">
              <div className="text-2xl md:text-3xl font-black text-orange-400">{stat.value}</div>
              <div className="text-xs text-gray-300 mt-1 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/60"></i>
        </div>
      </div>
    </section>
  );
}
